/**************************************************
 * Nombre:       Seccion_ContratosID
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CODIGO_DATO,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_FECHA_DINERO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ArrowBack, ManageSearch, Timeline} from "@mui/icons-material";
import {ESTADOSCONTRATO} from "../../Constantes";
import Dialogo_Contrato from "../Dialogos/Contratos/Dialogo_Contrato";
import {useNavigate} from "react-router";
import Dialogo_Contrato_Crear from "../Dialogos/Contratos/Dialogo_Contrato_Crear";
import {where} from "firebase/firestore";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {useParams} from "react-router-dom";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";


const Seccion_ContratosID = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [wheres, setWheres] = useState([where('idUsuario', '==', 'none')]);
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'contratos', wheres: wheres});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Contrato,
        titulo: 'Detalles del Contrato ',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoCrea, abrir: abrirCrea} = useDialogo({
        Componente: Dialogo_Contrato_Crear,
        titulo: 'Creando Contrato (No se paga Bonos ni puntos)',
        realizado: cargarNuevamente
    })
    const [usuario, setUsuario] = useState({})
    const [contrato, setContrato] = useState({})
    const [filtro, setFiltro] = useState('')

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'movimientos':
                navigate('/MovimientosID/idContrato/' + data.id)

                break
            default :
                abrir(data)
        }
    }


    useEffect(() => {

        if (params.tipo && params.id) {

            let tipo = params.tipo
            let id = params.id

            let w = [where(tipo, '==', id)]
            setWheres(w)

            obtenerDoc('cuentas', id).then((dox) => {
                if (dox.res) {
                    setUsuario(dox.data)
                }
            })


        }

    }, [params]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoCrea/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -3, mb: -3}}>
                    <Button
                        onClick={() => window.history.back()}
                        variant={'text'} startIcon={<ArrowBack/>}>Atras</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Lista contratos de ${usuario.nombre}`}
                        descripcion={`${numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrirCrea}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_ContratosID

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y Nombre',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Correo',
        direccion: 'left',
        propiedad: 'correo',
        titulo: 'hash',
        tipo: CASILLA_CODIGO_DATO
    },
    {
        nombre: 'Inicia',
        direccion: 'left',
        propiedad: 'valor',
        fecha: 'fechaInicio',
        tipo: CASILLA_FECHA_DINERO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSCONTRATO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Movimientos',
        id: 'movimientos',
        icono: Timeline
    }
]